export const CREATE_AGENCY = "CREATE_AGENCY";
export const CREATE_AGENCY_SUCCESS = "CREATE_AGENCY_SUCCESS";
export const CREATE_AGENCY_FAILED = "CREATE_AGENCY_FAILED";
export const CREATE_AGENCY_RESET = "CREATE_AGENCY_RESET";